import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import {
    GeneralBlockBody,
    GeneralBlockHeader,
    GeneralBlockTitle,
    GeneralBlockValue,
} from 'src/registry/components/blocks/GeneralBlock';
import { Skeleton } from 'src/registry/ui/Skeleton';
import { cn } from 'src/utils/shadcn';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

interface AttributeProps {
    label: string;
    value?: string | number | null;
    link?: string;
    icon?: IconProp;
    children?: React.ReactNode;
    isLoading?: boolean;
    className?: string;
}

const GeneralBlockAttribute = ({ label, value, link, icon, children, isLoading, className }: AttributeProps) => {
    return (
        <div className={cn('flex flex-col', className)}>
            <GeneralBlockHeader variant="dashboard">
                <GeneralBlockTitle>{label}</GeneralBlockTitle>
            </GeneralBlockHeader>
            <GeneralBlockBody variant="dashboard">
                {isLoading ? (
                    <Skeleton className="h-6 w-full max-w-48" />
                ) : (
                    (children ?? (
                        <GeneralBlockValue
                            size="small"
                            className={cn('break-all', link && value && 'text-primary-700 font-medium')}
                        >
                            {link && value ? (
                                <Link to={link}>
                                    {value}
                                    {icon && (
                                        <FontAwesomeIcon icon={icon} className="text-primary-700 pl-1 font-medium" />
                                    )}
                                </Link>
                            ) : (
                                (value ?? '-')
                            )}
                        </GeneralBlockValue>
                    ))
                )}
            </GeneralBlockBody>
        </div>
    );
};

export default GeneralBlockAttribute;
